import { useEffect, useState } from "react"
import { classBorderLabelDark, classBt, classbtAzul, classbtColunasVermelho, classInput, classInputDark, classLabel, classLabelDark } from "../../Utils/Types"
import { FaSave } from "react-icons/fa"
import { FcNook } from "react-icons/fc"
import { IoEye } from "react-icons/io5"

type Props = {
    show: boolean,
    CloseModalEvent: () => void,
    SaveClick: (titulo: string, conteudo: string) => void,
    modalTitulo: string,
    modalConteudo: string,
    loading?: boolean,

    id?: number
}

export const ModalCadObsEmpresa = ({ show, CloseModalEvent, SaveClick, modalConteudo, modalTitulo, loading, id }: Props) => {

    const [titulo, setTitulo] = useState("")
    const [conteudo, setConteudo] = useState("")
    const [visualizar, setVisualizar] = useState(false)


    const handleTituloChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTitulo(e.target.value)
    }

    const handleConteudoChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setConteudo(e.target.value)
    }

    useEffect(() => {
        setTitulo(modalTitulo)
        setConteudo(modalConteudo)

        if (modalTitulo === "") {
            setVisualizar(false)
        } else {
            setVisualizar(true)
        }

    }, [modalTitulo, modalConteudo])

    useEffect(() => {
        if (show) {


            //console.log("id: ", id)

            let modal = document.getElementById("modal_cad_obs_empresa");
            let modalContent = document.getElementById("modal_cad_obs_empresa_content");

            if (modal) {
                modal.style.visibility = 'visible';

                if (modalContent) {
                    modalContent.classList.remove('mt-[-500px]');
                    modalContent.classList.add('mt-24');
                }
            }


            const timeOutFocus = setTimeout(() => {
                const input = document.getElementById('titulo_obs')

                if (input) {
                    input.focus()
                }

            }, 100)

        } else {

            let modal = document.getElementById("modal_cad_obs_empresa");
            let modalContent = document.getElementById("modal_cad_obs_empresa_content");

            if (modal) {
                modal.style.visibility = 'hidden';


                if (modalContent) {
                    modalContent.classList.add('mt-[-500px]');
                    modalContent.classList.remove('mt-24');
                }
            }

            setTitulo("")
            setConteudo("")

        }
    }, [show])

    const handleSaveObs = () => {
        SaveClick(titulo, conteudo)
    }

    return (

        <div id="modal_cad_obs_empresa" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className="flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40">

            <div id="modal_cad_obs_empresa_content" className="relative flex flex-col w-[90%] sm:w-[70%] lg:w-[60%] xl:w-[40%] 2xl:w-[30%] h-[400px] bg-white dark:bg-slate-600 rounded-lg mt-[-500px] transition-all duration-300 justify-center items-center">

                {/* Header */}
                <div className={`absolute top-0 w-full h-[70px] flex items-center border border-x-0 border-t-0 border-slate-300 dark:border-slate-700`}>
                    
                    { id && id > 0 ?
                        <IoEye className="px-4 w-auto h-auto text-slate-700 dark:text-slate-200" size={'30px'} />
                        :
                        <FcNook className="px-4 w-auto h-auto" size={'30px'} />
                    }
                    <span className="text-base font-semibold leading-6 text-slate-700 dark:text-white">{id && id > 0 ? `Visualizar Observação - ${titulo}` : 'Cadastro de Observação'}</span>
                </div>
                {/* Header */}

                {/* Body */}
                <div className={`absolute top-[70px] bottom-[60px] w-full h-full p-4`}>

                    <div className={`grid grid-cols-12 gap-5`}>

                        <div className="relative col-span-12">
                            <input type="text" id="titulo_obs" className={`${classInput} ${classInputDark} ${visualizar ? 'cursor-not-allowed' : ''}  `} placeholder=" " autoComplete="off" value={titulo} onChange={handleTituloChange} disabled={visualizar} />
                            <label htmlFor="titulo_obs" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} `}>Título da Observação</label>
                        </div>

                        <div className="relative col-span-12">
                            <textarea id="conteudo" className={`${classInput} ${classInputDark} ${visualizar ? 'cursor-not-allowed' : ''} resize-none h-[150px]`} placeholder=" " autoComplete="off" value={conteudo} onChange={handleConteudoChange} disabled={visualizar} />
                            <label htmlFor="conteudo" className={`${classLabel} ${classLabelDark}  ${classBorderLabelDark} `}>Conteúdo da Observação</label>
                        </div>

                    </div>

                </div>
                {/* Body */}

                {/* Footer */}
                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button
                        onClick={CloseModalEvent}
                        disabled={loading}
                        className={`${classbtColunasVermelho} max-w-[150px]`}>
                        {id && id > 0 ? 'VOLTAR' : 'CANCELAR'}
                        
                    </button>

                    <button disabled={visualizar}
                        onClick={handleSaveObs}
                        className={`${classbtAzul} ${classBt} ${id && id > 0 ? 'hidden' : 'block    '} max-w-[150px]`}>
                        {!loading && <FaSave className="text-white w-4 h-4 mx-1" />}
                        {loading &&
                            <div className="h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]"
                                role="status">
                                <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
                            </div>
                        }
                        {!loading ? <span className="text-start">SALVAR</span> : <span className="text-start">AGUARDE</span>}
                    </button>

                </div>
                {/* Footer */}

            </div>

        </div>

    )


}